export default __webpack_public_path__ + "static/media/ic_tail_16.e6c0dc3f.svg";